import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'underscore';
import moment from 'moment';
import { acAxiosRequest } from '../actions/acAxiosRequest'
import { acMobToggle } from '../actions/acMobToggle';
import Notification from '../containers/Notification'
import StatisticiNumere from '../containers/StatisticiNumere'
import Mid1ConNrRunde from './Mid1ConNrRunde';
import ConBile from './ConBile';
import RandomNumbers from '../containers/RandomNumbers'
import Paytable from '../containers/Paytable'
import ScrollX from '../containers/ScrollX'
import NrFavorite from '../containers/NrFavorite'
import NrFavoriteMiddle from '../containers/NrFavoriteMiddle'

class Mid1ConNr extends React.Component {

    constructor() {
        super();
        this.state = {
            coun: 0,
            coteMob: false,
            star: ''
        };
    }

    odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
        }
        return odds;
    }
    toggleMobile() {
        if (this.props.mobToggle === true) {
            return 'mob'
        } else {
            return ''
        }
    }
    nrOdds() {
        var arr = [], odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            if (this.props.activeLot.odds[i].slice(-3) === '000') {
                odds.push(this.props.activeLot.odds[i].slice(0, -3) + 'k')
            } else {
                odds.push(this.props.activeLot.odds[i])
            }
        }
        for (let i = 0; i < this.props.activeLot.nr_odds; i++) {
            arr.push(
                <td key={i}>
                    <div>{i + 1}</div>
                    <div className="cote">{odds[i]}</div>
                </td>)
        }
        return [
            <td key="777" className="dn700"><div className="info dn700">
                <span className="infoTable">
                    <img title={this.props.multiLang.hitsNb.txt} className="infoTable" id="info-img" src="img/icon/info.svg" alt="" />
                    <p className="txt">{this.props.multiLang.hitsNb.txt}</p>
                </span>
                <span className="infoTable">
                    <img title={this.props.multiLang.odds.txt} className="infoTable" id="info-img" src="img/icon/info.svg" alt="" />
                    <p className="txt">{this.props.multiLang.odds.txt}</p>
                </span>
            </div></td>,
            arr
        ]
    }
    toggleOverlay() {
        this.props.acMobToggle(!this.props.mobToggle)
    }
    loadingActive() {
        if (this.props.loading === 'RUNDE') {
            // return 'active'
        }
        else {
            return ''
        }
    }

    coteShowMob() {
        this.setState({ coteMob: !this.state.coteMob })
    }
    coteShowMobClass() {
        if (this.state.coteMob === false) {
            return 'dn';
        }
        else if (this.state.coteMob === true) {
            return '';
        }
    }
    _odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            if (this.props.activeLot.odds[i].slice(-3) === '000') {
                odds.push(<td key={i}>{this.props.activeLot.odds[i].slice(0, -3) + 'k'}</td>)
            } else {
                odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
            }
        }
        return odds
    }
    nrFav() {
        if (this.props.appProps.colMid === "Mid1ConNr" && this.props.nrFavoriteMiddle !== null) {
            if (this.props.nrFavoriteMiddle !== undefined) {
                return <NrFavoriteMiddle />
            }
        } else if (this.props.nrFavorite !== null) {
            return <NrFavorite />
        } else {
            return <div></div>
        }

    }
    runda() {
        if (this.props.rundaSelectata !== null) {
            return (
                <tr className="active">
                    <td className="time_round">
                        <span>
                            <span>{moment(this.props.rundaSelectata.timeStart).format('DD.MM')}</span>
                            <span>{moment(this.props.rundaSelectata.timeStart).format('HH:mm')}</span>
                        </span>
                        <span>{this.props.activeLot.name_lot + ' | ' + this.props.activeLot.game_type}</span>
                    </td>
                    <td className={this.state.star}>{this.nrFav()}</td>
                </tr>
            )
        }
    }
    getRounds() {
        var rundeUpcoming = []
        var runde = this.props.runde.map((val, i) => {
            return (
                <Mid1ConNrRunde
                    key={val.round_unique}
                    rundaVal={val}
                    index={i}
                />
            )
        })
        if (this.props.runde.length >= 10) {
            return runde
        } else {
            var leftNb = 15 - this.props.runde.length

            for (var i = 0; i < leftNb; i++) {
                rundeUpcoming.push(
                    <div key={i} className='rundeUpcoming con-round' >
                        <div className="draw">{this.props.multiLang.upcoming.txt}</div>
                        <div className="hour">{'--:--'}</div>
                        <div className="date">{'--.--'}</div>
                    </div>
                )
            }
            runde.push(rundeUpcoming)
            return runde
        }
    }
    rundeHeader() {
        let live
        if (this.props.liveLot === this.props.activeLot.name_lot) {
            live = 'live'
        }
        return (
            <table className={"runde " + live}>
                <tbody >
                    <tr>
                        <td
                            // onClick={this.coteShowMob.bind(this)}
                            colSpan="1">
                            <img className="live-header" src="img/icon/live.png" alt="" />
                            {/* <div className="live-header"><span>LIVE</span></div> */}
                            <span className="nextDraws">{this.props.multiLang.nextDraws.txt}</span>
                            <span onClick={this.coteShowMob.bind(this)} className="but-mob-cote">{this.props.multiLang.odds.txt}</span>
                            <div className="info">
                                <span>{this.props.multiLang.hitsNb.txt}</span>
                                <span>{this.props.multiLang.odds.txt}</span>
                            </div>
                        </td>
                        {this.nrOdds()}
                    </tr>
                </tbody >
            </table>
        )
    }
    nrStatistici() {
        if (this.props.conSizeChange.appW <= 999 && this.props.loterii) {
            return (<StatisticiNumere />)
        }
    }
    randomNumbers() {
        if (this.props.appProps.randomNumbers === true) {
            return (
                <RandomNumbers />
            )
        }
    }
    paytable() {
        if (this.props.appProps.paytable === true && this.props.activeLot !== null) {
            return (
                <Paytable />
            )
        }
    }

    disableNoTicket() {
        if (this.props.bilete && this.props.bilete.length > 0) {
            return false
        } else {
            return true
        }
    }
    addFav() {
        var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        var chkDuplicate = _.contains(this.props.nrFavoriteMiddle.value, findBilet.numereArr.join());
        if (chkDuplicate === false && findBilet) {
            var axios = {
                ruta: this.props.appProps.ruta,
                reducer: 'NR_FAVORITE_MIDDLE',
                request: 'save_user_favorites',
                value: 'lottery_name=' + findBilet.numeLot.replace(/ /g, "_") + '&numbers=' + findBilet.numereArr + '',
                error: '8260',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(axios);

            this.setState({ star: 'star' });
            setTimeout(() => {
                this.setState({ star: '' });
            }, 1000);
        }
    }
    addFavNb() {
        return (
            <div className="controls">
                <button className="addFav" disabled={this.disableNoTicket()} onClick={this.addFav.bind(this)}>{this.props.multiLang.addFavNb.txt}</button>
            </div>
        )
    }
    render() {

        var width_runde = this.props.conSizeChange.colMidW - 51
        if ((this.props.activeLot !== null) && (this.props.runde !== null)) {
            var nrRunde = ''
            if (this.props.runde.length < 11) {
                nrRunde = 'no-scroll'
            }
            return (
                <div className={"mid-list-dd " + this.toggleMobile()}>
                    <div className="mob-overlay" onClick={this.toggleOverlay.bind(this)}></div>
                    <div className={"loading " + this.loadingActive()}></div>
                    <div className="col-mid-mob-header">
                        <span>{this.props.multiLang.runda.txt}</span>
                    </div>
                    {this.nrStatistici()}

                    <div>
                        {this.rundeHeader()}
                        <table className={"mob-odds " + this.coteShowMobClass()}>
                            <tbody>
                                <tr>
                                    {this.nrOdds()}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Notification/>
                    <div className="con-con-runde-ora">
                        <div className={"con-runde-ora " + nrRunde}>
                            <ScrollX
                                scrollData={this.getRounds()}
                                width={width_runde}
                                height='inherit'
                                amount={170}
                                speed={10}
                                info={'runde'}

                            />
                        </div>
                    </div>
                    <table className="main">
                        <tbody >
                            {this.runda()}

                            <tr className={'con-bile-tr'}>
                                <td colSpan="10">
                                    <ConBile />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {this.addFavNb()}
                    {this.randomNumbers()}
                    {this.paytable()}
                </div>
            )
        }
        else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        activeLot: state.activeLot,
        runde: state.runde,
        toggleMobile: state.toggleMobile,
        multiLang: state.multiLang,
        mobToggle: state.mobToggle,
        loading: state.loading,
        conSizeChange: state.conSizeChange,
        rundaSelectata: state.rundaSelectata,
        liveLot: state.liveLot,
        nrFavorite: state.nrFavorite,
        nrFavoriteMiddle: state.nrFavoriteMiddle,
        bilete: state.bilete,
        biletTab: state.biletTab,
        loterii: state.loterii,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acMobToggle: acMobToggle,
        // acToggleMobile: acToggleMobile,
        // acConSizeChange: acConSizeChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Mid1ConNr);
